import { render, staticRenderFns } from "./OrderPriceTooltip.vue?vue&type=template&id=76efeaa7&"
import script from "./OrderPriceTooltip.vue?vue&type=script&lang=js&"
export * from "./OrderPriceTooltip.vue?vue&type=script&lang=js&"
import style0 from "./OrderPriceTooltip.vue?vue&type=style&index=0&id=76efeaa7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports